"use client";

import * as React from "react";
import { OnePopChevronRightIcon } from "./icons";
import "../styles/onepop.css";

/**
 * ONEpop Available 카드의 "Get ONEUSD ›" 링크를 그대로 재현한 트리거.
 *
 * `<GetOneUsd mode="button" buttonComponent={OnePopGetTokenTrigger}>` 의
 * 커스텀 트리거로 쓰라고 있는 컴포넌트다 — 위젯이 넘기는 `onClick`/`disabled`/
 * `aria-label` 은 그대로 받고, 위젯 기본 스킨(`gou-fab` className, 토큰
 * 아이콘 + APR children)만 버린다. 그래서 지갑 안의 생김새는 딥링크 시절과
 * 1px 도 달라지지 않고, 클릭은 위젯의 액션 선택 모달로 간다.
 */
export const OnePopGetTokenTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(function OnePopGetTokenTrigger(
  // 위젯 스킨은 의도적으로 버린다.
  { className: _className, children: _children, ...props },
  ref,
) {
  return (
    <button
      {...props}
      ref={ref}
      type="button"
      className="wi-op-link-btn"
      data-track="onepop_get_token"
    >
      <span>Get ONEUSD</span>
      <OnePopChevronRightIcon size={12} />
    </button>
  );
});
